export default {
  // ========== GradeTableRanges ==========
  selectedRange: 'Rango seleccionado:',
  gradeRanges: 'Rangos de notas',
  colors: 'Colores',
  color: 'Color',
}
